import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Download } from 'lucide-react';
export function SolutionRevealSection() {
  return <section className="w-full bg-[#0B6B3A] text-white py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-172">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-173"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-black opacity-10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-174"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-176">
          <span className="inline-block px-4 py-1.5 bg-white/10 backdrop-blur-sm rounded-full text-green-100 font-medium text-sm mb-6 border border-white/20" data-id="element-177">
            La Solución Definitiva
          </span>

          <h2 className="text-3xl sm:text-5xl font-bold mb-6 leading-tight" data-id="element-178">
            Por eso existe <br data-id="element-179" />
            <span className="text-[#DCF8C6]" data-id="element-180">DM/WhatsApp Cierre Rápido</span>
          </h2>

          <p className="text-xl sm:text-2xl text-green-50 max-w-2xl mx-auto mb-10 leading-relaxed font-light" data-id="element-181">
            Un PDF ultra práctico, diseñado para que lo abras y digas: <br data-id="element-182" />
            <span className="font-bold text-white" data-id="element-183">
              "Ok… cuando me dicen X, yo respondo Y."
            </span>
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto text-center" data-id="element-184">
            {[{
            text: 'Sin inventar',
            icon: '🚫'
          }, {
            text: 'Sin improvisar',
            icon: '🎭'
          }, {
            text: 'Sin sentirte intenso/a',
            icon: '😌'
          }].map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2 + idx * 0.1
          }} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/10" data-id="element-185">
                <div className="text-3xl mb-2" data-id="element-186">{item.icon}</div>
                <div className="font-semibold text-white" data-id="element-187">{item.text}</div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}